import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";

import AsImg1 from "../../assets/CarBusiness/전시장1.png";
import AsImg2 from "../../assets/CarBusiness/전시장2.png";
import AsImg3 from "../../assets/CarBusiness/전시장3.png";
import AsImg4 from "../../assets/CarBusiness/전시장4.png";
import AsImg5 from "../../assets/CarBusiness/전시장5.png";
import AsImg6 from "../../assets/CarBusiness/전시장6.png";
import AsImg7 from "../../assets/CarBusiness/전시장7.png";
import AsImg8 from "../../assets/CarBusiness/전시장8.png";

// const AsImg1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/02. 자일분당.c3ac2bc0b3887c749a6f.png`;
// const AsImg2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/03. 자일평촌.05ef45eb531abc5cc13a.png`;
// const AsImg3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/04. 자일일산.e6dcb8cc72c34e8492f9.png`;
// const AsImg4 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/05. 자일청주.1ee0aa47e5571c386174.png`;
// const AsImg5 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/06. 자일익산.cc45034af1b8a1f5ce2c.png`;
// const AsImg6 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/07. 자일남대구.35271e1d65b91554244b.png`;
// const AsImg7 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/08. 자일포항.f2e01db74beb96d73750.png`;
// const AsImg8 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/09. 자일월암.826ae0765853175c5de3.png`;
// const AsImg9 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/10. 자일사상.ca71c7d980260a531c32.png`;
// const AsImg10 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/11. 자일김해.993a8513d2b4bf7f2989.png`;
// const AsImg11 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/12. 자일양산.3b07cc630447e3da0a21.png`;
// const AsImg12 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/13. 자일제주.4b0daf39b59dc31a4ab7.png`;
const Introduce = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"자동차판매사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <div className="kor">자동차사업</div>
              <div className="eng">Car Business</div>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"320px"}>
            <S.NavItem>
              <Link to="/CarBusiness/Sales">
                <div className="kor">자동차 판매사업</div>
                <div className="eng">Automotive Sales Business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/introduce">
                              <div className="kor">자동차사업</div>
                              <div className="eng">Car Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/Sales">
                              <div className="kor">자동차 판매사업</div>
                              <div className="eng">Automotive Sales Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/AsService">
                              <div className="kor">AS정비사업</div>
                              <div className="eng">AS maintenance business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/RentalService">
                              <div className="kor">렌터카 사업</div>
                              <div className="eng">Vehicle Rental Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/AsParts">
                              <div className="kor">A/S 부품 사업</div>
                              <div className="eng">After-Sales (A/S) Parts Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/CarBusinessHistory">
                              <div className="kor">자동차사업이력</div>
                              <div className="eng">Major business history</div>
                            </Link>
                          </S.NavItem>
                        </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"자동차 판매사업(8곳)"} titleeng={"Automotive Sales Business (8 Dealerships)"} />

            <div className="page-text">
                <div className="kor"><h2>YA모터스(르노 판매) 7곳 / YA오토(캐딜락 & GMC 판매) 1곳</h2></div>
                <div className="eng"><h2>YA Motors (Renault) Dealerships : 7  / YA Auto (Cadillac & GMC) Dealership : 1</h2></div>
            </div>

            <S.AsList>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">1.양산 전시장(YA모터스)</div>
                  <div className="eng">1.Yangsan Show-room (YA Motors)</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg1} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    위치 : 경남 양산시 양산역1길7 시외버스터미널
                  </div>
                  <div className="eng">
                    Location : 7 Yangsanyeok 1-gil, Yangsan-si, Gyeongsangnam-do
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">2. 남울산 전시장(YA모터스)</div>
                  <div className="eng">2. Namulsan Show-room (YA Motors)</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg2} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    위치 : 울산 남구 삼산로 147
                  </div>
                  <div className="eng">
                    Location : 147 Samsan-ro, Nam-gu, Ulsan
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">3. 창원 전시장(YA모터스)</div>
                  <div className="eng">3.Changwon Show-room (YA Motors)</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg3} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    위치 : 창원시 원이대로 716
                  </div>
                  <div className="eng">
                  Location : 716 Woni-daero, Seongsan-gu, Changwon-si,<br/>
                   Gyeongsangnam-do
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">4. 해운대 전시장(YA모터스)</div>
                  <div className="eng">4. Haeendae Show-room (YA Motors)</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg4} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    위치 : 부산 해운대구 좌동로 67
                  </div>
                  <div className="eng">
                    Location :  67 Jwadong-ro, Haeundae-gu, Busan
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">5. 쌍용 전시장(YA모터스)</div>
                  <div className="eng">5. Ssangyong Show-room (YA Motors)</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg5} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    위치 : 충남 천안시 서북구 월봉4로 6
                  </div>
                  <div className="eng">
                    Location : 6 Wolbong 4-ro, Seobuk-gu, Cheonan-si,<br />
                   Chungcheongnam-do
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">6. 정관 전시장(YA모터스)</div>
                  <div className="eng">6. Jeonggwan Show-room (YA Motors)</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg6} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    위치 : 부산 기장군 정관읍 용수로 21
                  </div>
                  <div className="eng">
                  Location : 21 Yongsu-ro, Jeonggwan-eup, Gijang-gun, Busan
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">7. 웅상 전시장(YA모터스)</div>
                  <div className="eng">7. Ungsang Show-room (YA Motors)</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg7} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    위치 : 경남 양산시 덕계로 151
                  </div>
                  <div className="eng">
                  Location : 151 Deokgye-ro, Yangsan-si, Gyeongsangnam-do
                  </div>
                </div>
              </S.AsItem>
              
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">8. 부산 전시장(YA오토)</div>
                  <div className="eng">8.Busan Show-room(YA Auto)</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg8} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    위치 : 부산시 해운대구 해운대로 581
                  </div>
                  <div className="eng">
                  Location : 581 Haeun-daero, Haeundae-gu, Busan
                  </div>
                </div>
              </S.AsItem>
              
            </S.AsList>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Introduce;
